/**
 * Google and Bing render with JS and would otherwise be assigned like any
 * visitor, so a crawl of the origin page could end on the experiment
 * destination. Crawlers always get control: they never enter a redirect
 * experiment, never record exposure, and never get a variant cookie.
 */
export const EXPERIMENT_CRAWLER_UA =
  /Googlebot|AdsBot-Google|Mediapartners-Google|Google-InspectionTool|GoogleOther|Storebot-Google|APIs-Google|FeedFetcher-Google|bingbot|BingPreview|msnbot|adidxbot|MicrosoftPreview/i;

export const isExperimentCrawler = (userAgent: string | undefined): boolean =>
  EXPERIMENT_CRAWLER_UA.test(userAgent || '');

/**
 * Inline guard for blocking head scripts. Returns from the enclosing
 * function when the user agent is a crawler.
 */
export const CRAWLER_SKIP_GUARD = `if(${EXPERIMENT_CRAWLER_UA.toString()}.test(navigator.userAgent||''))return;`;

/** Wraps an inline head script so crawlers skip it entirely. */
export const skipForCrawlers = (script: string): string =>
  `(function(){try{${CRAWLER_SKIP_GUARD}}catch(e){}${script}})();`;
